(function() {
    'use strict';

    window.THF.Angular.JoinForm.factory('thfFieldDefinitionCover', function() {
        return {
            'memberType': {
                'label': 'Who is this cover for?',
                'labelStyle': 'alternate',
                'name': 'memberType',
                'defaultValue': '',
                'placeholder': 'Enter your first name',
                'tooltip': '',
                'options': [
                    {'label': 'Single', 'icon': {src: window.THF.SiteSettings.svgSprite + '#ui-single', viewBox: '0 0 20 26'}, 'value': 'Sgl'},
                    {'label': 'Couple', 'icon': {src: window.THF.SiteSettings.svgSprite+'#ui-couple', viewBox: '0 0 40 26'}, 'value': 'Cpl'},
                    {'label': 'Family', 'icon': {src: window.THF.SiteSettings.svgSprite+'#ui-family', viewBox: '0 0 40 23.99'}, 'value': 'Fam'},
                    {'label': 'Single Parent', 'icon': {src: window.THF.SiteSettings.svgSprite+'#ui-single-parent', viewBox: '0 0 27.83 26'}, 'value': 'SPFam'}
                ],
                'validation': [
                    'required'
                ]
            },

            'state': {
                'label': 'State',
                'labelStyle': 'alternate',
                'name': 'primaryState',
                'defaultValue': '',
                'placeholder': '',
                'tooltip': '',
                'options': joinFormPageData.state,
                'onChange': function(newValue, oldValue, tabModel, formModel) {
                    if( newValue != oldValue ) {
                        formModel.contact.homeAddress = '';

                        DSTAPI.track('event', {
                            category: 'Join Form - Your Cover',
                            action: 'State',
                            label: newValue
                        });
                    }
                },
                'validation': [
                    'required'
                ]
            },

            'hospitalCover': {
                'label': 'Hospital Cover',
                'labelStyle': '',
                'name': 'hospitalCover',
                'defaultValue': 'TH',
                'placeholder': '',
                'tooltip': 'Our Hospital covers provide benefits for a range of services received when you are admitted to hospital (in-patient). Hospital cover can be taken on its own or with an Extras product to provide you with greater cover for services such as dental and optical.',
                'options': angular.copy(joinFormPageData.hospitalCover),
                'onChange': function (newValue, oldValue, tabModel, formModel) {
                    var options = angular.copy(joinFormPageData.hospitalCover);
                    var optionIndex = _.findKey(options, { 'value': newValue });

                    DSTAPI.track('event', {
                        category: 'Join Form - Your Cover',
                        action: 'Hospital',
                        label: options[optionIndex].label
                    });
                },
                'validation': [
                    'required'
                ],
                link: {
                    href: '',
                    show: false
                },
                modal: {
                    show: false,
                    id: 0
                }
            },

            'extrasCover': {
                'label': 'Extras Cover',
                'labelStyle': '',
                'name': 'extrasCover',
                'defaultValue': 'Anc',
                'placeholder': '',
                'tooltip': 'Our Extras covers are designed to assist you in taking care of your well-being, by providing benefits towards services that help you to lead a healthy lifestyle, such as dental, optical and physio.',
                'options': _.filter(joinFormPageData.extrasCover, function(o){return (o.value != 'Amb');}),
                'onChange': function (newValue, oldValue, tabModel, formModel) {
                    var options = _.filter(joinFormPageData.extrasCover, function (o) { return (o.value != 'Amb'); });
                    var optionIndex = _.findKey(options, { 'value': newValue });

                    DSTAPI.track('event', {
                        category: 'Join Form - Your Cover',
                        action: 'Extras',
                        label: options[optionIndex].label
                    });
                },
                'validation': [
                    'required'
                ],
                link: {
                    href: '',
                    show: false
                },
                modal: {
                    show: false,
                    id: 0
                }
            },

            'emergencyAmbulance': {
                'label': '',
                'labelStyle': '',
                'name': 'emergencyAmbulance',
                'defaultValue': '',
                'placeholder': '',
                'tooltip': '',
                'options': [
                    {'label': 'Emergency Ambulance cover only', 'value': 'Amb'}
                ],
                'validation': []
            },

            'nonStudentDependant': {
                'label': '',
                'labelStyle': '',
                'name': 'nonStudentDependant',
                'defaultValue': '',
                'placeholder': '',
                'tooltip': joinFormPageData.nonStudentDependantCheckboxTooltip,
                'options': [
                    {
                        'label': joinFormPageData.nonStudentDependantCheckboxText,
                        'value': 'Y'
                    }
                ],
                'validation': []
            },

            'memberDateOfBirth': {
                'label': 'Date Of Birth',
                'name': 'memberDOB',
                'defaultValue': '',
                'placeholder': 'DD/MM/YYYY',
                'tooltip': '',
                'mask': '99/99/9999',
                'datePickerOptions': {
                    yearRange: '-110nn:-nn',
                    minDate: moment().month(0).subtract('110', 'years').toDate(),
                    maxDate: moment().toDate(),
                    defaultDate: moment().format('DD/MM/YYYY')
                },
                'onChange': function(newValue, oldValue, tabModel, formModel) {
                    formModel.personal.memberDOB = newValue;

                    DSTAPI.track('event', {
                        category: 'Join Form - Your Cover',
                        action: 'Date of Birth',
                        label: newValue
                    });
                },
                'validation': [
                    'required',
                    'thfDateOfBirth'
                ]
            },
            'partnerDateOfBirth': {
                'label': 'Partner Date Of Birth',
                'name': 'partnerDOB',
                'defaultValue': '',
                'placeholder': 'DD/MM/YYYY',
                'tooltip': '',
                'mask': '99/99/9999',
                'datePickerOptions': {
                    yearRange: '-110nn:-nn',
                    minDate: moment().month(0).subtract('110', 'years').toDate(),
                    maxDate: moment().toDate(),
                    defaultDate: moment().format('DD/MM/YYYY')
                },
                'onChange': function(newValue, oldValue, tabModel, formModel) {
                    formModel.personal = formModel.personal || {};
                    formModel.personal.partner = formModel.personal.partner || {};
                    formModel.personal.partner.partnerDOB = newValue;
                },
                'validation': [
                    'required',
                    'thfDateOfBirth'
                ]
            },

            'coverStartDate': {
                'label': 'Cover Start Date',
                'name': 'coverStartDate',
                'defaultValue': moment().format('YYYY-MM-DD'),
                'placeholder': 'DD/MM/YYYY',
                'tooltip': 'Select the date you would like your cover to start.',
                'mask': '99/99/9999',
                'datePickerOptions': {
                    minDate: moment().toDate(),
                    maxDate: moment().add(2, 'months').toDate(),
                },
                'onChange': function (newValue, oldValue, tabModel, formModel) {
                    DSTAPI.track('event', {
                        category: 'Join Form - Your Cover',
                        action: 'Cover Start Date',
                        label: newValue
                    });
                },
                'validation': [
                    'required',
                    'thfDateCoverStart'
                ]
            },

            'medicareEligibility': {
                'label': 'Are you eligible for Medicare?',
                'name': 'medicareEligibility',
                'defaultValue': 'Y',
                'placeholder': '',
                'tooltip': 'Please confirm that those listed on this policy (partner and/or dependants) are eligible for Medicare entitlements.',
                'options': [
                    {'label': 'Yes', 'value': 'Y'},
                    {'label': 'No', 'value': 'N'}
                ],
                'onChange': function (newValue, oldValue, tabModel, formModel) {
                    DSTAPI.track('event', {
                        category: 'Join Form - Your Cover',
                        action: 'Eligible',
                        label: newValue
                    });
                },
                'validation': [
                    'required'
                ]
            },

            'governmentRebate': {
                'label': '',
                'name': 'governmentRebate',
                'defaultValue': 'Y',
                'placeholder': '',
                'tooltip': '',
                'options': [
                    {'label': 'Yes, apply my rebate level at', 'value': 'Yes'}
                ],
                'validation': []
            },

            'governmentRebateIncomeTier': {
                'label': '',
                'name': 'governmentRebateIncomeTier',
                'defaultValue': '0',
                'placeholder': '',
                'tooltip': 'Select the Income Tier that applies to you from the drop down list, or "Base Tier" if you wish to receive the full Australian Government rebate. To determine the Private Health Insurance Tier that relates to your membership, please visit the Australian Taxation Office private health insurance rebate calculator at ato.gov.au. For more information, visit the Australian Government website for Private health Insurance at privatehealth.gov.au.',
                'options': joinFormPageData.incomeSingle,
                'validation': []
            },

            'bdo': {
                'label': '',
                'labelStyle': '',
                'name': 'bdo',
                'defaultValue': THF.Utility.Location.queryParam('bdo'),
                'placeholder': '',
                'tooltip': '',
                'options': [],
                'validation': []
            },

            'contactCentre': {
                'label': '',
                'labelStyle': '',
                'name': 'contactCentre',
                'defaultValue': THF.Utility.Location.queryParam('contact_centre'),
                'placeholder': '',
                'tooltip': '',
                'options': [],
                'validation': []
            },

            'utm': {
                'label': '',
                'labelStyle': '',
                'name': 'utm',
                'defaultValue': THF.Interface.CampaignCapture.getCapturedQueryString(),
                'placeholder': '',
                'tooltip': '',
                'options': [],
                'validation': []
            }
        };
    });
})();
